import axios from "axios";

export const state = {
    subjectcompetencies: [],
};

export const getters = {
    subjectcompetencies: state => state.subjectcompetencies,
};

export const mutations = {
    setSubject(state, newValue) {
        state.subjectcompetencies = newValue
    },
};

export const actions = {
    fetchSubjectCompetencies({ commit }) {
        axios.get('/subjectcompetencies').then(res => {
            commit('setSubject', res.data.subjectcompetencies);
        })
    },
};
